<template>
  <v-container>
    <v-layout
      text-xs-center
      wrap
    >
      <v-flex xs12>
        <v-img
          :src="require('../assets/hammann.jpg')"
          class="my-3"
          contain
          height="200"
        ></v-img>
      </v-flex>

      <v-flex mb-4>
        <h1 class="display-2 font-weight-bold mb-3">
          Welcome to Hammann Line Bot
        </h1>
        <div class="subheading font-weight-regular">
          <br>For help and collaboration with Hammann developers,
          <br>please join our groups
          <br>Azur Lane: <a class="headline font-weight-bold mb-1" href="http://line.me/R/ti/g/6rVq5K3Fi6" target="_blank">Here.</a>
          <br>Granblue Fantasy: <a class="headline font-weight-bold mb-1" href="http://line.me/R/ti/g/DuCC" target="_blank">Here.</a>
        </div>
      </v-flex>

      <v-flex  mb-5  xs12>
        <h2 class="headline font-weight-bold mb-3">Hamamans!!~~ henn~tai!!~~</h2>
      </v-flex>


        <v-flex xs12 mb-5>
          <v-layout justify-center>
            <router-link class="subheading mx-3" to="about">About</router-link>
            <router-link class="subheading mx-3" to="commands">Commands</router-link>
            <router-link class="subheading mx-3" to="stickers">Stickers</router-link>
          </v-layout>
        </v-flex>

      <v-flex
        xs12
        mb-5
      >
        <h2 class="headline font-weight-bold mb-3">Developer Links</h2>

        <v-layout justify-center>
          <a
            v-for="(eco, i) in ecosystem"
            :key="i"
            :href="eco.href"
            class="subheading mx-3"
            target="_blank"
          >
            {{ eco.text }}
          </a>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      ecosystem: [
        {
          text: 'BlackMix',
          href: 'https://github.com/BlackMix'
        },
        {
          text: 'vue-genesis-forms',
          href: 'https://github.com/BlackMix/vue-genesis-forms'
        },
        {
          text: 'kawaii-jwt',
          href: 'https://github.com/KawaiiWaifus/kawaii-jwt'
        }
      ]
    })
  }
</script>

<style>

</style>
